import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/title_bj.png';
const _hoisted_1 = {
  class: "tit_bj"
};
const _hoisted_2 = ["innerHTML"];
export default /*@__PURE__*/_defineComponent({
  __name: 'commonTit',
  props: {
    title: {},
    isFlipped: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["common-tit", {
          'flipped': __props.isFlipped
        }])
      }, [_createElementVNode("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        class: "tit_bj_img",
        src: _imports_0,
        alt: "Title Background"
      }, null, -1)), _createElementVNode("div", {
        class: _normalizeClass(["tit_bj_text", {
          'text-right': __props.isFlipped
        }]),
        innerHTML: __props.title
      }, null, 10, _hoisted_2)])], 2);
    };
  }
});